import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "miloffers_cookie_consent";

export default class extends Controller {
  connect() {
    if (this.storedChoice()) {
      this.element.classList.add("hidden");
      return;
    }
    this.element.classList.remove("hidden");
  }

  accept() {
    this.persist("accepted");
    this.hide();
  }

  reject() {
    this.persist("rejected");
    this.hide();
  }

  hide() {
    this.element.classList.add("hidden");
  }

  persist(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (_) {}
  }

  storedChoice() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (_) {
      return null;
    }
  }
}
